import React from 'react'

import Layout from "../../component/Layout/Layout";
import PendingAuthenticationStripe from "./PendingAuthenticationStripe";
import {getSessionIsManagedByPartner} from "../../utils/auth";

class PendingAuthentication extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        if (getSessionIsManagedByPartner()) {
            return <Layout activeMenu="/billing" isLoggedIn={true}>
                Billing is managed by your partner.
            </Layout>;
        }

        return <Layout activeMenu="/billing" isLoggedIn={true}>
            <h1>Pending authentication</h1>
            <PendingAuthenticationStripe history={this.props.history}/>
        </Layout>
    }
}

export default PendingAuthentication